const updates = [
  { date: '07-31', title: '《庆余年2》全36集高清上线', tag: '新剧', tagColor: 'accent' },
  { date: '07-30', title: '《唐朝诡事录之西行》更新至第38集', tag: '更新', tagColor: 'primary' },
  { date: '07-29', title: '《墨雨云间》4K修复版全网首发', tag: '4K', tagColor: 'accent' },
  { date: '07-28', title: '《大奉打更人》超前点映全集上线', tag: '首发', tagColor: 'primary' },
  { date: '07-27', title: '《狂飙》导演剪辑版独家放送', tag: '独家', tagColor: 'accent' },
  { date: '07-26', title: '《长相思2》大结局超前上线', tag: '完结', tagColor: 'secondary' },
  { date: '07-25', title: '《凡人歌》全40集一次性放出', tag: '全集', tagColor: 'primary' },
  { date: '07-24', title: '《山花烂漫时》评分9.1高分上线', tag: '高分', tagColor: 'accent' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">最新上线</h2>
          <span className="text-xs text-foreground-500 bg-background-800/70 px-3 py-1 rounded-full">实时更新</span>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-4 md:left-5 top-2 bottom-2 w-px bg-background-700/50"></div>

          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative group cursor-pointer">
                <div className={`absolute left-[-23px] md:left-[-27px] top-2 w-3 h-3 rounded-full border-2 ${
                  i === 0 ? 'bg-accent-500 border-accent-500' : 'bg-background-900 border-background-600'
                }`}></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 p-4 rounded-xl hover:bg-background-800/30 transition-colors">
                  <span className="flex-shrink-0 text-xs font-mono text-foreground-600 bg-background-800/70 px-2.5 py-1 rounded-full w-fit">{item.date}</span>
                  <span className="flex-1 text-sm text-foreground-300 group-hover:text-foreground-100 transition-colors">{item.title}</span>
                  <span className={`flex-shrink-0 text-[10px] font-semibold px-2.5 py-1 rounded-full w-fit ${
                    item.tagColor === 'accent' ? 'bg-accent-500/15 text-accent-400' :
                    item.tagColor === 'primary' ? 'bg-primary-500/15 text-primary-400' :
                    'bg-secondary-500/15 text-secondary-400'
                  }`}>
                    {item.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}